module.exports = __webpack_public_path__ + "img/bg.a6f9888e.png";